import axios from "axios";
import route from "ziggy-js";
import { sortBy } from "lodash";
import { useQuery, useMutation, useQueryClient } from "@tanstack/vue-query";

export const QUERY_KEY = ["sites"];

async function addBuilding(data) {
    const { data: r } = await axios.post(route("api.sites.store"), data);
    return r.data;
}

export function useAddBuilding() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: addBuilding,
        onSuccess: (newBuilding) => {
            queryClient.setQueryData(QUERY_KEY, (oldBuildings) => [
                ...oldBuildings,
                newBuilding,
            ]);
        },
        onSettled: () => {
            queryClient.invalidateQueries({ queryKey: QUERY_KEY });
        },
    });
}

export async function fetchSites() {
    const { data: r } = await axios.get(route("api.sites.all"));
    return r.data;
}

export function useSites() {
    return useQuery({
        queryKey: QUERY_KEY,
        queryFn: fetchSites,
        select: (data) => sortBy(data, "name"),
        refetchOnMount: true,
    });
}
